import * as Sentry from '@sentry/browser';

import LogoIcon from '~/components/app/sidebar/LogoIcon';
import history from '~/lib/history';

import styles from './errorHandler.style';

class ErrorHandler extends React.Component {
  state = {
    error: false,
  };

  componentDidMount() {
    this.listener = history.listen(this.reset);
  }

  componentDidCatch(error, errorInfo) {
    if (window.location.hostname !== 'localhost') {
      this.setState({ error });

      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);

        Sentry.captureException(error);
      });
    }
  }

  componentWillUnmount() {
    if (this.listener) this.listener();
  }

  reset = () => {
    if (this.state.error) {
      this.setState({ error: false });
    }
  };

  onClickBack() {
    history.back();
  }

  render() {
    const { children, classes } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <div className={classes.root}>
          <div className={classes.container}>
            <LogoIcon className={classes.logo} />
            <div className={classes.title}>Whoops!</div>
            <div className={classes.text}>
              There was an error loading the page.
            </div>
            <div className={classes.text}>
              Please go{' '}
              <a
                className={classes.link}
                href=""
                onClick={() => this.onClickBack()}
              >
                back
              </a>{' '}
              and try again.
            </div>
          </div>
        </div>
      );
    } else {
      return children;
    }
  }
}

ErrorHandler.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ErrorHandler);
